import {
  Button,
  List,
  ListItem,
  XMarkIcon
} from "@dealer-center/core-components";
import styled from "styled-components";

interface PermissionsToAddProps {
  permissions: string[];
  onRemove: (permission: string) => void;
}

const StyledPermissionsContainer = styled.div`
  width: 100%;
`;
const StyledList = styled(List)`
  margin-top: 1rem;
  width: 100%;
`;
const StyledListItem = styled(ListItem)`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
`;

const StyledRemoveButton = styled(Button)`
  display: flex;
`;

const PermissionsToAdd = ({ permissions, onRemove }: PermissionsToAddProps) => {
  return (
    <StyledPermissionsContainer>
      <StyledList square={true}>
        {permissions.map(permission => (
          <StyledListItem
            data-testid={permission}
            id={permission}
            key={permission}
          >
            <div>{permission}</div>
            <StyledRemoveButton
              analyticsConfiguration={{
                eventName: "Remove Permission"
              }}
              buttonStyle="aux"
              data-testid={`delete`}
              onClick={e => {
                e.stopPropagation();
                e.preventDefault();
                onRemove(permission);
              }}
            >
              <XMarkIcon title="Remove Permission" />
            </StyledRemoveButton>
          </StyledListItem>
        ))}
      </StyledList>
    </StyledPermissionsContainer>
  );
};

export default PermissionsToAdd;
